import { getPath } from '@/router/common'

const baseUrl = {
  title: '分单配载',
  path: 'fdpz'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'fdpz_index',
    component: () => import(/* webpackChunkName: "fdpz_index" */ '@/views/fdpz/index/index.vue'),
    meta: {
      title: '分单配载'
    }
  },
  {
    path: getPath('zctb', baseUrl),
    name: 'ZCTB',
    component: () => import('@/views/fdpz/zctb/index.vue'),
    meta: {
      title: '整车申报'
    }
  },
  {
    path: getPath('fdpz_printView', baseUrl),
    name: 'Fdpz_PrintView',
    component: () => import(/* webpackChunkName: "fdpz_printView" */ '@/views/fdpz/fdpz_printView/index.vue'),
    meta: {
      title: '打印'
    }
  },
  {
    path: getPath('fdpz_pzqdRPTList', baseUrl),
    name: 'fdpz_fdpz_pzqdRPTList',
    component: () => import(/* webpackChunkName: "fdpz_fdpz_pzqdRPTList" */ '@/views/fdpz/fdpz_pzqdRPTList/index.vue'),
    meta: {
      title: '打印清单'
    }
  },
  {
    path: getPath('fdpz_htqm', baseUrl),
    name: 'fdpz_fdpz_htqm',
    component: () => import(/* webpackChunkName: "fdpz_fdpz_htqm" */ '@/views/fdpz/fdpz_htqm/index.vue'),
    meta: {
      title: '操作员签名'
    }
  },
  {
    path: getPath('fdpzadd', baseUrl),
    name: 'fdpz_fdpzadd',
    component: () => import(/* webpackChunkName: "fdpz_fdpzadd" */ '@/views/fdpz/fdpzadd/index.vue'),   
    meta: {
      title: '沿途配载-新增|分单配载-新增'
    }
  },
  {
    path: getPath('fdpzadd_landing', baseUrl),
    name: 'fdpzadd_landing',
    component: () => import(/* webpackChunkName: "fdpzadd_landing" */ '@/views/fdpz/fdpzadd_landing/index.vue'),   
    meta: {
      title: '落地配配载-新增'
    }
  },
  {
    path: getPath('fdpzGetDataFromStock', baseUrl),
    name: 'fdpz_fdpzGetDataFromStock',
    component: () => import(/* webpackChunkName: "fdpz_fdpzGetDataFromStock" */ '@/views/fdpz/fdpzGetDataFromStock/index.vue'),
    meta: {
      title: '第①步：从库存中提取运单'
    }
  },
  {
    path: getPath('fdpzADDSecondStep', baseUrl),
    name: 'fdpz_fdpzADDSecondStep',
    component: () => import(/* webpackChunkName: "fdpz_fdpzADDSecondStep" */ '@/views/fdpz/fdpzADDSecondStep/index.vue'),
    meta: {
      title: '第②步：填写车辆等信息并完成'
    }
  },

  // 落地配配载 第一步
  {
    path: getPath('fdpzGetDataFromStock_landing', baseUrl),
    name: 'fdpz_fdpzGetDataFromStock_landing',
    component: () => import(/* webpackChunkName: "fdpz_fdpzGetDataFromStock_landing" */ '@/views/fdpz/fdpzGetDataFromStock_landing/index.vue'),
    meta: {
      title: '第①步：从库存中提取运单'
    }
  },

  // 落地配配载 第二步
  {
    path: getPath('fdpzADDSecondStep_landing', baseUrl),
    name: 'fdpz_fdpzADDSecondStep_landing',
    component: () => import(/* webpackChunkName: "fdpz_fdpzADDSecondStep_landing" */ '@/views/fdpz/fdpzADDSecondStep_landing/index.vue'),
    meta: {
      title: '第②步：填写车辆等信息并完成'
    }
  },
  {
    path: getPath('fdpzUPD', baseUrl),
    name: 'fdpz_fdpzUPD',
    component: () => import(/* webpackChunkName: "fdpz_fdpzUPD" */ '@/views/fdpz/fdpzUPD/index.vue'),
    meta: {
      title: '配载清单'
    }
  },
  {
    path: getPath('fdpzUPD_bcqd', baseUrl),
    name: 'fdpz_fdpzUPD_bcqd',
    component: () => import(/* webpackChunkName: "fdpz_fdpzUPD_bcqd" */ '@/views/fdpz/fdpzUPD_bcqd/index.vue'),
    meta: {
      title: '本车清单'
    }
  },
  {
    path: getPath('index', baseUrl),
    name: 'test_index',
    component: () => import(/* webpackChunkName: "test_index" */ '@/views/test/index/index.vue'),
    meta: {
      title: '本车清单->配载清单打印'
    }
  },
  {
    path: getPath('fdpzUPD_YSHT', baseUrl),
    name: 'fdpz_fdpzUPD_YSHT',
    component: () => import(/* webpackChunkName: "fdpz_fdpzUPD_YSHT" */ '@/views/fdpz/fdpzUPD_YSHT/index.vue'),
    meta: {
      title: '运输合同'
    }
  },
  {
    path: getPath('fdpzUPD_HTJS', baseUrl),
    name: 'fdpz_fdpzUPD_HTJS',
    component: () => import(/* webpackChunkName: "fdpz_fdpzUPD_HTJS" */ '@/views/fdpz/fdpzUPD_HTJS/index.vue'),
    meta: {
      title: '合同结算信息'
    }
  },
  {
    path: getPath('fdpzUPD_WTLY', baseUrl),
    name: 'fdpz_fdpzUPD_WTLY',
    component: () => import(/* webpackChunkName: "fdpz_fdpzUPD_WTLY" */ '@/views/fdpz/fdpzUPD_WTLY/index.vue'),
    meta: {
      title: '选择承运商'
    }
  },
  {
    path: getPath('outrate', baseUrl),
    name: 'fdpz_outrate',
    component: () => import(/* webpackChunkName: "fdpz_outrate" */ '@/views/fdpz/outrate/index.vue'),
    meta: {
      title: '出库比率'
    }
  },
  {
    path: getPath('fdpz_ypz', baseUrl),
    name: 'fdpz_fdpz_ypz',
    component: () => import(/* webpackChunkName: "fdpz_fdpz_ypz" */ '@/views/fdpz/fdpz_ypz/index.vue'),
    meta: {
      title: '预配载'
    }
  },
  {
    path: getPath('free_insurance_introduce', baseUrl),
    name: 'free_insurance_introduce',
    component: () => import(/* webpackChunkName: "free_insurance_introduce" */ '@/views/fdpz/freeInsurance/introduce/index.vue'),
    meta: {
      title: '货运险投保'
    }
  }, {
    path: getPath('free_insurance_insurance', baseUrl),
    name: 'free_insurance_insurance',
    component: () => import(/* webpackChunkName: "free_insurance_insurance" */ '@/views/fdpz/freeInsurance/insurance/index.vue'),
    meta: {
      title: '赠险投保页'
    }
  },
  {
    path: getPath('third_pard_insurance_info', baseUrl),
    name: 'third_pard_insurance_info',
    component: () => import(/* webpackChunkName: "third_pard_insurance_info" */ '@/views/fdpz/freeInsurance/thirdPartInsuranceInfo/index.vue'),
    meta: {
      title: '投保页'
    }
  },
]
